export const MODAL_NAMES = {
  RESET_PASSWORD_EXPLANATION: 'RESET_PASSWORD_EXPLANATION',
}

export const VALIDATION_ERROR = '/errors/validation-error'
